export const SET_CONFIG = 'SET_CONFIG';
